import { ReactElement, Fragment } from 'react';

import { queries } from '@zoopla-eng/zds-components/themes';
import {
    CmsArticleCollection,
    CmsArticleCollectionProps
} from '@zoopla/cms/article-collection';
import { Banner } from '@zoopla/banner';

import {
    ArticleCollection as ArticleCollectionGQL,
    CampaignCta as CampaignCTAGQL,
    Banner as BannerGQL,
    ContentBlock
} from '../../graphql.generated';
import { WidgetWrapper } from '../pages/Homepage.styles';

import BackupCampaignCtaImage from '../assets/backup-campaign-cta.jpg';
import {
    CampaignCta,
    HomeValuationForm
} from '@zoopla/landing-pages/campaign-cta';
import { Document } from '@contentful/rich-text-types';

type HomePageCampaignCTA = Omit<CampaignCTAGQL, 'title' | 'description'> & {
    ccTitle: string;
    ccDescription: string;
};

type HomePageBanner = Omit<BannerGQL, 'description'> & {
    bannerDescription: Document;
};

export const contentMapper = (contentBlock: ContentBlock[]) => {
    const components: ReactElement[] = [];
    const componentMap: Record<string, (props: any) => JSX.Element> = {
        articleCollection: (props: ArticleCollectionGQL) => (
            <CmsArticleCollection
                articleCollectionData={{
                    ...props,
                    contentType: props.contentType as string
                }}
                carouselConfig={{
                    breakpoints: [
                        {
                            size: queries.M[100],
                            numCards: 3
                        }
                    ]
                }}
                seeMoreLink={
                    props.seeMoreLink as CmsArticleCollectionProps['seeMoreLink']
                }
                horizontalCardLayout={false}
            />
        ),
        campaignCta: (props: HomePageCampaignCTA) => (
            <CampaignCta
                title={props.ccTitle}
                body={props.ccDescription || ''}
                image={props.image?.url || BackupCampaignCtaImage}
            >
                <HomeValuationForm eventCategory="homepage" />
            </CampaignCta>
        ),
        componentBanner: (banner: HomePageBanner) => (
            <Banner
                title={banner.title}
                body={banner.bannerDescription}
                imageSrc={banner.imageSrc}
                bgColor={banner.backgroundColour}
                buttons={banner.buttons.map((button) => ({
                    label: button.buttonLabel || '',
                    url: button.buttonUrl || '',
                    category: button.category || 'primary'
                }))}
            />
        )
    };

    contentBlock.forEach((item, index) => {
        if (!item.contentType) {
            console.warn(`No content type found for ${JSON.stringify(item)}`);
        } else {
            if (componentMap[item.contentType]) {
                components.push(
                    <Fragment key={index}>
                        {componentMap[item.contentType](item)}
                    </Fragment>
                );
            } else {
                console.warn(
                    `Content mapping does not yet support ${item.contentType}.`
                );
            }
        }
    });

    return components;
};
